export function registerFormComponents (vue) {
  const components = require.context('@/components/Form', false, /(.vue)$/)
  components.keys().forEach(file => {
    const config = components(file)
    const component = `Ovp${file.replace('./', '').replace('.vue', '')}`

    vue.component(component, config.default || config)
  })
}

export function registerIconComponent (vue) {
  const config = require('@/components/Container/Icon')
  const component = 'OvpIcon'
  vue.component(component, config.default || config)
}

export function registerTypographyComponent (vue) {
  const config = require('@/components/Container/Typography')
  const component = 'OvpTypography'
  vue.component(component, config.default || config)
}